module.exports = __webpack_public_path__ + "static/media/c2bannerModul3_small.8a178eed.jpg";